module.exports = __webpack_public_path__ + "img/srsm.a1be3016.png";